<header class="site-header">
  <a data-testid="flow-logo" [routerLink]="['/']" class="logo-link" inlineSVG="/assets/logo_primary_rgb.svg">
   Flow
  </a>

  <button class="mobile-nav" inlineSVG="/assets/icons/menu.svg" (click)="toggleMobileMenu()" role="button"></button>

  <nav [class.active]="mobileMenuActive">
    <button data-testid="mobile-menu" class="mobile-close" inlineSVG="/assets/icons/plus-3.svg" (click)="toggleMobileMenu()"></button>
    <a *ngIf="showSecondaryNavButtons" [routerLink]="['/']" (click)="onScrollToProducts()">Products</a>
    <a *ngIf="showSecondaryNavButtons" data-testid="team-nav-menu-item" [routerLink]="['/team']" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">Team</a>
    <!-- <a *ngIf="showSecondaryNavButtons" href="https://blog.flowinc.com/">Blog</a> -->
    <a [routerLink]="['/login']" class="main-action" *ngIf="!loggedIn">Login</a>
    <a [routerLink]="['/dashboard']" class="main-action" *ngIf="loggedIn">Dashboard</a>
  </nav>
</header>
